import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";
import { CONTACT, NAV_LINKS, PROFILE_PDF } from "../data";
import { Download } from "lucide-react";

export const Footer = () => (
  <footer className="relative bg-bg border-t border-ink/10 pt-20 pb-10" data-testid="footer">
    <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-20">
      <div className="grid md:grid-cols-12 gap-10 pb-16">
        <div className="md:col-span-5">
          <Logo className="text-ink" />
          <p className="mt-6 font-display italic text-2xl text-ink/70 max-w-sm leading-snug">Financing India's Green Transition.</p>
          <p className="mt-5 font-body text-sm text-ink/40 max-w-sm">{CONTACT.address}</p>
          <a href={PROFILE_PDF} download className="mt-6 inline-flex items-center gap-2 font-heading text-xs font-semibold tracking-wide border border-ink/20 text-ink/80 px-5 py-3 hover:bg-ink hover:text-white transition-colors duration-300" data-testid="footer-download-profile">
            <Download size={14} /> Download Company Profile
          </a>
        </div>
        <div className="md:col-span-3">
          <div className="overline text-ink/35 mb-5">Explore</div>
          <ul className="space-y-3">
            {[{ label: "Home", to: "/" }, ...NAV_LINKS, { label: "Contact", to: "/contact" }].map((l) => (
              <li key={l.to}><Link to={l.to} className="font-body text-sm text-ink/55 hover:text-brand-green transition-colors" data-testid={`footer-link-${l.to.slice(1) || "home"}`}>{l.label}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="overline text-ink/35 mb-5">Contact</div>
          <ul className="space-y-3 font-body text-sm">
            <li><a href={CONTACT.phoneHref} className="text-ink/55 hover:text-brand-green transition-colors">{CONTACT.phone}</a></li>
            <li><a href={`mailto:${CONTACT.emailPrimary}`} className="text-ink/55 hover:text-brand-green transition-colors">{CONTACT.emailPrimary}</a></li>
            <li><a href={`mailto:${CONTACT.emailGeneral}`} className="text-ink/55 hover:text-brand-green transition-colors">{CONTACT.emailGeneral}</a></li>
          </ul>
          <div className="mt-6 overline text-ink/25 text-[9px] leading-relaxed">{CONTACT.legalName}<br/>CIN {CONTACT.cin}</div>
        </div>
      </div>
      <div className="pt-8 border-t border-ink/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="font-body text-xs text-ink/30">© {new Date().getFullYear()} Ashutosh Capital. Established 1983 · Ahmedabad. RBI-Registered NBFC.</p>
        <p className="font-body text-xs text-ink/25 max-w-xl md:text-right">Registrations not valid for acceptance of public deposits. Content is indicative and does not constitute an offer of financial services.</p>
      </div>
    </div>
  </footer>
);
